import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { CatalogueEntry } from "../CatalogueEntry";
import DataCache from "../../../Services/DataCache";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import { Catalogue } from "@singularsystems/neo-react-services";
import ContactType from "../../../Models/Catalogue/General/ContactType";

export default class ContactTypeCatalogueEntry extends CatalogueEntry<ContactType> {

    constructor() {
        super("Contact Types", ContactType);
    }

    public get editRole() {
        return CatalogueRoles.ContactTypes.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.contactTypes;
    }
    
    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return apiClient.saveContactTypes;
    }
    
    public renderRow(item: ContactType, meta: Model.TransformMetaType<ContactType>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.contactTypeName} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}